<template>
  <div class="title-box" :class="lineType">
    <h2>{{ titleContent }}</h2>
  </div>
</template>

<script>

export default {
  name: 'section-content-title',
  props: ['titleContent', 'lineType'],
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
